import React from 'react'
import {MasterFiltersDto} from '../../../hoteleria/features/modules/models'
import {selectMapperByKeys} from '../../mappers/util'
import {useCentralServices} from '../central/useCentralServices'

export const useFloors = () => {
  const [loading, setLoading] = React.useState(false)
  const [floors, setFloors] = React.useState<{value: string; label: string}[]>([])
  //   const {getBeds} = useHoteleriaServices()
  const {getParams} = useCentralServices()

  const getFloorsFn = async (
    qntLevels: number,
    filters: MasterFiltersDto = {},
    options: {idKey: string; labelKey: string} = {idKey: 'id', labelKey: 'nombreCorto'},
  ) => {
    try {
      setLoading(true)
      const floors = await getParams({pageNumber: 1, size: 100, tableName: 'Nivel'}, filters)
      const orderedData = floors.sort((a, b) => parseInt(a.codigo) - parseInt(b.codigo))
      const filterData = orderedData.slice(0, qntLevels)
      const mappedFloors = selectMapperByKeys(
        filterData,
        options.idKey as any,
        options.labelKey as any,
      )
      setFloors(mappedFloors)
    } catch (error) {
      console.error('Error fetching floors:', error)
    } finally {
      setLoading(false)
    }
  }

  const clearFloors = () => {
    setFloors([])
  }

  return {
    loading,
    floors,
    getFloors: getFloorsFn,
    clearFloors,
  }
}
